import { lazy } from 'react';
export var TeamEditPageAdminAsync = lazy(function () { return import('./TeamEditPage'); });
